import { render, staticRenderFns } from "./createBatch.template.vue?vue&type=template&id=7255ecac&scoped=true&"
var script = {}
import style0 from "./createBatch.template.vue?vue&type=style&index=0&id=7255ecac&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7255ecac",
  null
  
)

export default component.exports